import { observer } from 'mobx-react-lite';
import modalStore from '../../stores/modalStore';
import { logClientEvent } from '../../hooks/useAnalytics';
import { twMerge } from 'tailwind-merge';
import { HelpCircleIcon } from 'lucide-react';

export const GuideButton = observer(
    ({
        docKey,
        className,
        children,
    }: {
        docKey: string;
        className?: string;
        children: React.ReactNode;
    }) => {
        return (
            <button
                className={twMerge('btn', className)}
                onClick={async (e) => {
                    e.preventDefault();

                    await modalStore.guide({ docKey });

                    logClientEvent('guide', {
                        doc_key: docKey,
                    });
                }}
            >
                {children}
            </button>
        );
    },
);

/**
 * 안내 버튼
 */
export const GuideIconButton = observer(
    ({ docKey, className }: { docKey: string; className?: string }) => {
        return (
            <GuideButton
                docKey={docKey}
                className={twMerge(
                    'btn btn-circle btn-ghost text-base-content/30 btn-sm border-none bg-transparent shadow-none',
                    className,
                )}
            >
                <HelpCircleIcon className="size-4" />
            </GuideButton>
        );
    },
);
